import type { Truck, TruckCreate } from '../types/user'
import { api } from './fetch'

export interface TruckResponse {
  id: number
  truck_number: string
  truck_type: string
  license_number: string
  yard_address: string
}

export const truckService = {
  async getUserVehicles(userId: number): Promise<TruckResponse[]> {
    try {
      const response = await api.get<TruckResponse[]>(
        `/user/${userId}/vehicles`,
      )
      return response.data
    } catch (error) {
      console.error('Failed to fetch vehicles:', error)
      throw error
    }
  },

  async addTruck(userId: number, truckData: TruckCreate): Promise<Truck> {
    try {
      const response = await api.post<Truck>(
        `/user/${userId}/vehicle`,
        truckData,
      )
      return response.data
    } catch (error) {
      console.error('Failed to add truck:', error)
      throw error
    }
  },

  async updateTruck(
    userId: number,
    truckId: number,
    truckData: Partial<TruckCreate>,
  ): Promise<TruckResponse> {
    try {
      const response = await api.patch<TruckResponse>(
        `/user/${userId}/vehicle/${truckId}`,
        truckData,
      )
      return response.data
    } catch (error) {
      console.error('Failed to update truck:', error)
      throw error
    }
  },

  async deleteTruck(userId: number, truckId: number): Promise<void> {
    try {
      await api.delete(`/user/${userId}/vehicle/${truckId}`)
    } catch (error) {
      console.error('Failed to delete truck:', error)
      throw error
    }
  },
}
